import ArrowLeft from "@/assets/icons/ArrowLeft";
import Hamburger from "@/assets/icons/Hamburger";
import TapNParkIcon from "@/assets/logo/TapNPark";
import { HStack } from "@/components/ui/hstack";
import LayoutConstants from "@/constants/Layout";
import sessionTokenStorage from "@/constants/SessionTokenStorage";
import { useCustomTheme } from "@/hooks/useCustomTheme";
import { getValueFromStorage } from "@/utils/secureStore";
import { DrawerActions } from "@react-navigation/native";
import { useT } from "@transifex/react";
import { Image } from "expo-image";
import { useGlobalSearchParams, useNavigation, usePathname, useRouter } from "expo-router";
import { useEffect, useState } from "react";
import { Pressable } from "react-native";
import { SafeAreaView, useSafeAreaInsets } from "react-native-safe-area-context";

export default function Header() {
  const router = useRouter();
  const { skin } = useCustomTheme();
  const insets = useSafeAreaInsets();
  const navigation = useNavigation();
  const t = useT();
  const [showMenu, setShowMenu] = useState(false);

  const pathname = usePathname();
  const { qr } = useGlobalSearchParams<{ qr?: string }>();

  const routesWithoutBackButton = ["/welcome", "/purchase/confirmation", "/redeem/confirmation"];
  if (!router.canGoBack() && pathname === "/receipt") {
    routesWithoutBackButton.push("/receipt");
  }

  useEffect(() => {
    async function go() {
      const sessionToken = sessionTokenStorage.getToken();
      if (sessionToken || (pathname === "/welcome" && qr)) {
        setShowMenu(true);
      }
    }

    go();
  }, [pathname, qr]);

  function handleBack(): void {
    if (routesWithoutBackButton.includes(pathname)) {
      return;
    }

    if (!router.canGoBack()) {
      router.replace("/welcome");
      return;
    }

    router.back();
  }

  function handleLogoPress() {
    getValueFromStorage("skin").then((storageSkin) => {
      if (storageSkin) {
        // Do not go to welcome without a skin loaded
        router.replace("/welcome");
      }
    });
  }

  return (
    <SafeAreaView className="bg-background-50 border-b border-outline-300 w-full" edges={["top"]} style={{ paddingTop: insets.top }}>
      <HStack className="flex-row gap-[16px] items-center justify-between px-[20] py-[16px] w-full" style={{ height: LayoutConstants.headerHeight }}>
        <Pressable className="h-full items-center justify-center w-[20px]" onPress={handleBack} data-test-id="header-back-button">
          {!routesWithoutBackButton.includes(pathname) && <ArrowLeft />}
        </Pressable>
        <Pressable onPress={handleLogoPress}>
          {skin.logoURL && pathname !== "/receipt" ? (
            <Image
              accessibilityLabel={t("Logo Image")}
              source={{ uri: skin.logoURL }}
              alt={t("Logo Image")}
              style={{ height: 50, width: 50 }}
              data-test-id="header-logo-image"
              contentFit="contain"
              allowDownscaling={false}
            />
          ) : (
            <TapNParkIcon width={120} />
          )}
        </Pressable>
        <Pressable className="h-full items-center justify-center" onPress={() => navigation.dispatch(DrawerActions.toggleDrawer())}>
          {showMenu && <Hamburger />}
        </Pressable>
      </HStack>
    </SafeAreaView>
  );
}
